import React, { useState, useEffect } from "react";
import "../styles/EventPopup.css";
// import eventImage from "../assests/images/marosa.png";
import eventImage from "../assests/images/cygnet.jpg";

export default function EventPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const endDate = new Date("2026-04-22T23:59:59");
    const today = new Date();

    if (today <= endDate) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, []);

  if (!open) return null;

  return (
    <div className="eventPopup-container">
      {/* Close Button */}
      <button className="eventPopup-close" onClick={() => setOpen(false)}>
        ×
      </button>

      {/* Show Only Image */}
      <img src={eventImage} alt="event popup" className="eventPopup-image" />

      {/* Register Now Button */}
      <a
        href="https://zoom.us/webinar/register/2717754576829/WN_H0DcrCtGQF6sceQdOCManQ#/registration"
        target="_blank"
        rel="noopener noreferrer"
        className="eventPopup-registerBtn"
      >
        Register Now
      </a>
    </div>
  );
}
